import Vue from 'vue'
import Router from 'vue-router'

import indexH5 from '@/components/page/indexH5'
import login from '@/components/page/login'
import userCenters from '@/components/page/userCenters'
import userCenters2 from '@/components/page/userCenters2'
import userCenterspw from '@/components/page/userCenterspw'


import setPass from '@/components/page/setPass'
import setPassConfirm from '@/components/page/setPassConfirm'
import changePass from '@/components/page/changePass'
import changePassConfirm from '@/components/page/changePassConfirm'
import changePassConfirmApp from '@/components/page/changePassConfirmApp'

import userApplist from '@/components/page/userApplist'
import userAppInfo from '@/components/page/userAppInfo'
import userAppInfotxs from '@/components/page/userAppInfotxs'


import userVip from '@/components/page/userVip'
import userVipNew from '@/components/page/userVipNew'
import userVipNew2 from '@/components/page/userVipNew2'

import personal from '@/components/page/personal'
import downapp from '@/components/page/downapp'
import downapptest from '@/components/page/downapptest'
import downappChannel from '@/components/page/downappChannel'
import downappTip from '@/components/page/downappTip'

import pay from '@/components/page/pay'
import pay2 from '@/components/page/pay2'
import payApp from '@/components/page/payApp'
import payApple from '@/components/page/payApple'



import payResult from '@/components/app/qml/pay/payResult'
import toshare from '@/components/page/toshare'
import toshareApp from '@/components/page/toshareApp'
import toshareNews from '@/components/page/toshareNews'


import share from '@/components/page/share/share'
import shareNews from '@/components/page/share/shareNews'


import channel from '@/components/page/channel/channel'

import apploading from '@/components/page/apploading'
import popLoad from '@/components/page/popLoad'

import indexLoad from '@/components/page/indexLoad'

import appchannel from '@/components/channel/channel'
import channelHybks from '@/components/channel/channelHybks'
import channelHyb from '@/components/channel/channelHyb'
import channelHybbd from '@/components/channel/channelHybbd'
import channelHybgdt from '@/components/channel/channelHybgdt'
import chanelResult from '@/components/channel/chanelResult'
import chanelResulttest from '@/components/channel/chanelResulttest'
import chanelResultDown from '@/components/channel/chanelResultDown'
import chaneldown from '@/components/channel/chaneldown'




import channelHybShare from '@/components/channel/channelHybShare'



import channelHybdy from '@/components/channel/channelHybdy'

import video from '@/components/video/video'

import contactKF from '@/components/contact/contactKF'
import showvip from '@/components/clac/showvip'

import showvipnew from '@/components/clac/showvipnew'
import showvipnewtest from '@/components/clac/showvipnewtest'

import cheat from '@/components/clac/cheat'

import settingIndex from '@/components/clac/setting'
import settingLocal from '@/components/clac/settingLocal'
import settinghw from '@/components/clac/settinghw'
import settingoppo from '@/components/clac/settingoppo'

import settingapple from '@/components/clac/settingapple'

import settingvivo from '@/components/clac/settingvivo'

import settingmi from '@/components/clac/settingmi'





import question from '@/components/clac/question'
import questionios from '@/components/clac/questionios'


import noviceguide from '@/components/clac/noviceGuide'

import noviceguideios from '@/components/clac/noviceguideios'




//协议
import registerAgree from '@/components/agreement/registerAgree'
import privacyAgree from '@/components/agreement/privacyAgree'
import privacyAgreexxl from '@/components/agreement/privacyAgreexxl'
import privacyAgreexxl2 from '@/components/agreement/privacyAgreexxl2'

import qmlRegisterAgree from '@/components/agreement/qmlRegisterAgree'
import qmlprivacyAgree from '@/components/agreement/qmlprivacyAgree'
import qmlprivacyAgreeShow from '@/components/agreement/qmlprivacyAgreeShow'
import qmlprivacyAgreeShow2 from '@/components/agreement/qmlprivacyAgreeShow2'
import privacyAgreeBaike from '@/components/agreement/qmlprivacyAgreeBaike'

import privacyAgreeApple from '@/components/agreement/privacyAgreeApple'

import downCalc from '@/components/downapp/downCalc'
import downCalcgdt from '@/components/downapp/downCalcgdt'
import downCalcbaidu from '@/components/downapp/downCalcbaidu'
import downCalcbaiduf from '@/components/downapp/downCalcbaiduf'


import iosSetting from '@/components/iosSetting/iosSetting'

import appFunctionRight from '@/components/agreement/appFunctionRight'
import appFunctionRightXxl from '@/components/agreement/appFunctionRightXxl'

//app页面
import qmlpay from '@/components/app/qml/pay/pay'
import qmlabout from '@/components/app/qml/about/about'
import qmlabout2 from '@/components/app/qml/about/about2'

//亲密聊
import qmldown from '@/components/qml/qmldown'
import qmlResult from '@/components/qml/qmlResult'

import buyonebyone from '@/components/active/buyonebyone'

import buyonebyone2 from '@/components/active/buyonebyone2'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: 'indexload/:cid',
      name: 'indexload',
      // 1.改这里
    },
    {
      path: '/index',
      name: 'indexH5',
      component: indexH5,
    },
    {
      path: '/app/qmldown',
      name: 'qmldown',
      component: qmldown

    },
    {
      path: '/app/qmlResult',
      name: 'qmlResult',
      component: qmlResult

    },
    {
      path: '/qmlResult',
      name: 'qmlResult',
      component: qmlResult

    },
    {
      path: '/logins',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/iosSetting',
      name: 'iosSetting',
      component: iosSetting,
    },
    
  
    {
      path: '/agree/register',
      name: 'registerAgree',
      component: registerAgree
    },
    {
      path: '/agree/privacyAgree',
      name: 'privacyAgree',
      component: privacyAgree
    },
  
    
    {
      path: '/agree/privacyAgreexxl',
      name: 'privacyAgreexxl',
      component: privacyAgreexxl
    },
    
    {
      path: '/agree/privacyAgreexxl2',
      name: 'privacyAgreexxl2',
      component: privacyAgreexxl2
    },
    {
      path: '/agree/appFunctionRight',
      name: 'appFunctionRight',
      component: appFunctionRight
    },
    {
      path: '/agree/appFunctionRightXxl',
      name: 'ppFunctionRightXxl',
      component: appFunctionRightXxl
    },
    {
      path: '/userCenters',
      name: 'userCenters',
      component: userCenters
    },

    {
      path: '/userCenters2',
      name: 'userCenters2',
      component: userCenters2
    },

    {
      path: '/userCenterspw',
      name: 'userCenterspw',
      component: userCenterspw
    },

    
    {
      path: '/setPass',
      name: 'setPass',
      component: setPass
    },
    {
      path: '/setPassConfirm',
      name: 'setPassConfirm',
      component: setPassConfirm
    },
    {
      path: '/changePass',
      name: 'changePass',
      component: changePass
    },
    {
      path: '/changePassConfirm',
      name: 'changePassConfirm',
      component: changePassConfirm
    },

    {
      path: '/changePassConfirmApp',
      name: 'changePassConfirmApp',
      component: changePassConfirmApp
    },

    {
      path: '/userApplist',
      name: 'userApplist',
      component: userApplist
    },
    {
      path: '/userAppInfo',
      name: 'userAppInfo',
      component: userAppInfo
    },
    {
      path: '/userAppInfotxs',
      name: 'userAppInfotxs',
      component: userAppInfotxs
    },
    {
      path: '/vip',
      name: 'userVipNew',
      component: userVipNew
    },

    {
      path: '/vip2',
      name: 'userVipNew2',
      component: userVipNew2
    },

    {
      path: '/userVipNew',
      name: 'userVipNew',
      component: userVipNew
    },

    

    {
      path: '/personal',
      name: 'personal',
      component: personal
    },
    {
      path: '/downapp',
      name: 'downapp',
      component: downapp
    },
    {
      path: '/downappChannel',
      name: 'downappChannel',
      component: downappChannel
    },
    
    {
      path: '/downapptest',
      name: 'downapptest',
      component: downapptest
    },
    {
      path: '/downappTip',
      name: 'downappTip',
      component: downappTip
    },
    
    {
      path: '/pay',
      name: 'pay',
      component: pay
    },

    {
      path: '/pay2',
      name: 'pay2',
      component: pay2
    },

    {
      path: '/payApp',
      name: 'payApp',
      component: payApp
    },
    {
      path: '/payApple',
      name: 'payApple',
      component: payApple
    },
    {
      path: '/payResult/:orderid',
      name: 'payResult',
      component: payResult
    },
    {
      path: '/toshare',
      name: 'toshare',
      component: toshare
    },
    
    {
      path: '/toshareNews',
      name: 'toshareNews',
      component: toshareNews
    },
    {
      path: '/share',
      name: 'share',
      component: share
    },
    {
      path: '/shareNews',
      name: 'shareNews',
      component: shareNews
    },
    {
      path: '/channel/:channelId',
      name: 'channel',
      component: channel
    },
    {
      path: '/appchannel/:channelId',
      name: 'appchannel',
      component: appchannel
    },
    {
      path: '/channelHyb/:channelId',
      name: 'channelHyb',
      component: channelHyb
    },

    {
      path: '/channelHybShare/:channelId/:userid',
      name: 'channelHybShare',
      component: channelHybShare
    },
    {
      path: '/channelHybShare/:channelId/',
      name: 'channelHybShare',
      component: channelHybShare
    },

    {
      path: '/channelHybks/:channelId',
      name: 'channelHybks',
      component: channelHybks
    },
    {
      path: '/channelHybbd/:channelId',
      name: 'channelHybbd',
      component: channelHybbd
    },
    {
      path: '/channelHybgdt/:channelId',
      name: 'channelHybgdt',
      component: channelHybgdt
    },
    {
      path: '/channelHybdy/:channelId',
      name: 'channelHybdy',
      component: channelHybdy
    },
    {
      path: '/appdown/downCalc/:channelId',
      name: 'downCalc',
      component: downCalc
    },
    {
      path: '/appdown/downCalcgdt/:channelId',
      name: 'downCalcgdt',
      component: downCalcgdt
    },
    {
      path: '/appdown/downCalcbaidu',
      name: 'downCalcbaidu',
      component: downCalcbaidu
    },
    {
      path: '/appdown/downCalcbaiduf',
      name: 'downCalcbaiduf',
      component: downCalcbaiduf
    },


    
    {
      path: '/appdown/chaneldown/:type/:channelId',
      name: 'chaneldown',
      component: chaneldown
    },

    

    {
      path: '/chanelResult',
      name: 'chanelResult',
      component: chanelResult
    },
    {
      path: '/chanelResulttest',
      name: 'chanelResulttest',
      component: chanelResulttest
    },
    {
      path: '/chanelResultDown',
      name: 'chanelResultDown',
      component: chanelResultDown
    },

    
    {
      path: '/app/apploading',
      name: 'apploading',
      component: apploading

    },

    {
      path: '/app/popLoad',
      name: 'popLoad',
      component: popLoad

    },

    
    {
      path: '/indexLoad',
      name: 'indexLoad',
      component: indexLoad
    },
    {
      path: '/app/toshareApp',
      name: 'toshareApp',
      component: toshareApp

    },
    {
      path: '/app/toshareApp/:user',
      name: 'toshareApp',
      component: toshareApp

    },
    {
      path: '/app/privacyAgree',
      name: 'qmlprivacyAgree',
      component: qmlprivacyAgree

    },
    {
      path: '/app/qmlprivacyAgreeShow',
      name: 'qmlprivacyAgreeShow',
      component: qmlprivacyAgreeShow

    },

    {
      path: '/app/qmlprivacyAgreeShow2',
      name: 'qmlprivacyAgreeShow2',
      component: qmlprivacyAgreeShow2

    },

    {
      path: '/app/privacyAgreeBaike',
      name: 'privacyAgreeBaike',
      component: privacyAgreeBaike

    },
    

    {
      path: '/app/privacyAgreeApple',
      name: 'privacyAgreeApple',
      component: privacyAgreeApple

    },
    
    {
      path: '/app/registerAgree',
      name: 'qmlRegisterAgree',
      component: qmlRegisterAgree

    },
    {
      path: '/app/qmlpay',
      name: 'qmlpay',
      component: qmlpay

    },
    {
      path: '/app/qmlabout',
      name: 'qmlabout',
      component: qmlabout

    },
    {
      path: '/app/qmlabout2',
      name: 'qmlabout2',
      component: qmlabout2

    },
    {
      path: '/app/video',
      name: 'video',
      component: video

    },
    {
      path: '/app/setting/index',
      name: 'settingIndex',
      component: settingIndex

    },
    {
      path: '/app/setting/local',
      name: 'settingLocal',
      component: settingLocal

    },
    {
      path: '/app/setting/hw',
      name: 'settinghw',
      component: settinghw

    },
    {
      path: '/app/setting/oppo',
      name: 'settingoppo',
      component: settingoppo

    },

    {
      path: '/app/setting/apple',
      name: 'settingapple',
      component: settingapple

    },
    {
      path: '/app/setting/vivo',
      name: 'settingvivo',
      component: settingvivo

    },
    {
      path: '/app/setting/mi',
      name: 'settingmi',
      component: settingmi

    },
    {
      path: '/contactKF',
      name: 'contactKF',
      component: contactKF
    },
    {
      path: '/showvip',
      name: 'showvip',
      component: showvip
    },
    {
      path: '/cheat',
      name: 'cheat',
      component: cheat
    },
    {
      path: '/showvip/:type',
      name: 'showvip',
      component: showvip
    },
    {
      path: '/showvipnew/:type',
      name: 'showvipnew',
      component: showvipnew
    },
    {
      path: '/showvipnewtest/:type',
      name: 'showvipnewtest',
      component: showvipnewtest
    },
    {
      path: '/question',
      name: 'question',
      component: question
    },
    {
      path: '/questionios',
      name: 'questionios',
      component: questionios
    },
    
    {
      path: '/noviceguide',
      name: 'noviceguide',
      component: noviceguide
    },
    {
      path: '/noviceguideios',
      name: 'noviceguideios',
      component: noviceguideios
    },

    

    
    {
      path: '/active/buyonebyone/:uid',
      name: 'buyonebyone',
      component: buyonebyone
    },

    {
      path: '/active/buyonebyone2/:uid',
      name: 'buyonebyone2',
      component: buyonebyone2
    },
    
    
    

    
    



  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js